import { Card, Col, Container, Row } from "reactstrap";
import ImageCropperBody from "./ImageCropperBody";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { ImageCropperTitle, UIKits } from "../../../Constants/Constants";
import { Breadcrumbs } from "../../../AbstractElements";

const ImageCropperContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ImageCropperTitle} parent={UIKits} />
      <Container fluid>
        <div className="img-cropper">
          <Row>
            <Col sm="12">
              <Card>
                <CommonCardHeader title={ImageCropperTitle} />
                <ImageCropperBody />
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};
export default ImageCropperContainer;
